<template>
  <div id="stud_main">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>


<div v-if="!data_details[0]">
  <div class="container">
  <div class="notification">
     <span class="has-text-weight-bold"> {{no_display}}</span>
  </div>
  </div>

</div>
<div v-else>

<div class="columns is-gapless is-mobile is-centered has-text-grey-dark pt-4" style="margin-bottom:0em;">
<div class="column is-4 has-background-light isLabel">Ponderation Desc.</div>
<div class="column is-2 has-background-light has-text-centered isLabel">Percent</div>
<div class="column is-2 has-background-light has-text-centered isLabel">Résultat</div>
<div class="column is-2 has-background-light has-text-centered isLabel">Pond. Moyen</div>
<!-- <div v-if="course_avg > -1"  class="column is-2 colBorder has-background-grey-dark has-text-white	 has-text-centered doFontSmaller">Cour Avg.</div>
<div v-else class="column is-2">&nbsp;</div> -->
</div>

<div class="columns is-gapless is-mobile is-centered has-text-weight-bold" style="margin-bottom:0em;" v-for ="(data, index) in data_details" :key="index">
<div class="column is-4 colBorder has-background-white doFontSmaller">&nbsp;&nbsp;{{data.ponderation_Desc}}</div>
<div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{data.ponderation_Percent}}%</div>

<template v-if="data.goodToGo">
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{return_average(data.note_NOTE, data.ponderation_Max)}}</div>
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{return_average(data.ponderation_AVG, data.ponderation_Max)}}</div>  
</template>
<template v-else>
  <div class="column is-2 colBorder has-background-white has-text-centered has-text-warning doFontSmaller"><span class="icon" style=""><i class="fas fa-clock"></i></span></div>
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller"></div> 
</template>






<!-- <div v-if="course_avg > -1 && index == 0"  class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{course_avg}}%</div>
<div v-else class="column is-2">&nbsp;</div> -->


</div>

</div>


  </div>
</template>


<script>
import axios from 'axios';


export default {
    props: [ 'student_id' , 'group_id', 'course_avg' ],
    
  data: function() {
    return {
        isLoading : false,
        data_details:[],
        no_display:'',
    }
  },


created() {
    this.get_details() 
},

  methods: {

get_details() {
    this.isLoading=true;
    //AND (MyMEQ_PROF_PONDERATION.ponderation_PUBLIC = 1)
    var sql=`
        SELECT distinct  MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_PROF_NOTES.note_NOTE, MyMEQ_PROF_PONDERATION.ponderation_Desc, MyMEQ_PROF_PONDERATION.ponderation_Percent, MyMEQ_PROF_PONDERATION.ponderation_AVG, MyMEQ_PROF_PONDERATION.ponderation_PUBLIC, MyMEQ_PROF_PONDERATION.ponderation_Max
        , CAST(IIF ( ponderation_PUBLIC = 1, 1, 0 ) AS BIT) as goodToGo, ponderation_Order FROM MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT.cs_ID = MyMEQ_PROF_NOTES.cs_ID INNER JOIN MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID
        WHERE MyMEQ_COURSESTUDENT.student_ID = ` + this.student_id + ` AND MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + `   
        ORDER BY ponderation_Order`
  console.log(sql)
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
        .then(res => { 
            if (!res.data[0]) { this.no_display = 'Résultats non disponibles'}
            this.data_details = res.data
            this.isLoading=false;
        });
}, // END GET DETAILS

return_average(val,max) {
    return Math.round((val / max) * 100) + '%'
}




  }, // END METHODS 

} // END SCRIPT
</script>





<style scoped>

.doFont {
  font-size: 4.0vmin;
}
.doFontSmaller {
  font-size: 2.0vmin;
}

</style>
